import { createElement } from 'react';
import type { UpdateOptions } from 'react-toastify';
import { toast } from 'react-toastify';
import { DEFAULT_TOAST_OPTIONS, DEFAULT_ERROR_DELAY, DEFAULT_SUCCESS_DELAY } from './vy-toast-consts';
import type { ToastRenderType } from './vy-toast-types/toast-render-type';
import { VyToastIcon } from './vy-toasts-components';

export function toastFromPromise<Response, Error>(
  promise: Promise<Response>,
  { error, pending, success }: ToastRenderType<Response, Error>,
) {
  return toast.promise<Response, Error, undefined>(promise, {
    success: {
      ...DEFAULT_TOAST_OPTIONS,
      type: 'success',
      delay: DEFAULT_SUCCESS_DELAY,
      render: success,
      icon: (iconProps) => createElement(VyToastIcon, { ...iconProps, type: 'success' }),
    } satisfies Omit<UpdateOptions<Response>, 'data'> as UpdateOptions<Response>,
    pending: {
      ...DEFAULT_TOAST_OPTIONS,
      render: pending,
    } satisfies Omit<UpdateOptions<undefined>, 'data'> as UpdateOptions<undefined>,
    error: {
      ...DEFAULT_TOAST_OPTIONS,
      type: 'error',
      delay: DEFAULT_ERROR_DELAY,
      render: error,
      icon: (iconProps) => createElement(VyToastIcon, { ...iconProps, type: 'error' }),
    } satisfies Omit<UpdateOptions<Error>, 'data'> as UpdateOptions<Error>,
  });
}
